import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import he from './locales/he.json';

export const LANGUAGES = [
  { code: 'en', name: 'English',  flag: '🇬🇧', dir: 'ltr' },
  { code: 'ar', name: 'العربية',  flag: '🇸🇦', dir: 'rtl' },
  { code: 'he', name: 'עברית',    flag: '🇮🇱', dir: 'rtl' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      he: { translation: he },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'he'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'gilron_lang',
    },
  });

// Keep <html dir> in sync with the active language
const applyDir = (lng) => {
  const meta = LANGUAGES.find((l) => l.code === lng) || LANGUAGES[0];
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng);
    document.documentElement.setAttribute('dir', meta.dir);
    document.body?.setAttribute('data-lang', lng);
  }
};
applyDir(i18n.language || 'en');
i18n.on('languageChanged', applyDir);

export default i18n;
